import config from './config';

function getDetailPeerings(params) {
	return Ajax.get(config.detailPeerings, params);	
}

function modifyPeeringName(params) {
	return Ajax.post(config.modifyPeerConn, params);	
}

export {
	getDetailPeerings,
	modifyPeeringName
};


// WEBPACK FOOTER //
// ./src/api/peering/detail/actions.js